module.exports = __webpack_public_path__ + "static/img/rev_auto.4cebe6d0.png";